<template>
  <VCardImportFormSection title="Phone Info">
    <v-row>
      <v-col cols="4">
        Direct Phone
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.phone.direct"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Mobile Phone
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.phone.mobile"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Office Phone
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.phone.office"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Fax Phone
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.phone.fax"
          :items="items"
        />
      </v-col>
    </v-row>
  </VCardImportFormSection>
</template>

<script lang="ts">
import mixins from 'vue-typed-mixins';

import { VCardSectionMixin } from '@/bundles/Contact/mixins/VCardSectionMixin';

export default mixins(VCardSectionMixin).extend({
  name: 'VCardImportPhoneInfo',
});
</script>
